// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3TSkX","title":"Info_title__1BQqw","selects":"Info_selects__Vlte_","requiredAsterisk":"Info_requiredAsterisk__3c-GM"};